import { Link } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useLanguage } from "../i18n/LanguageContext";

export default function NotFound() {
  const { lang } = useLanguage();
  const isEn = lang === "en";

  return (
    <main className="bg-[#0F1A2E] min-h-screen">
      <Navbar />
      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-40 pb-32 text-center relative overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-[#D4AF37]/[0.03] rounded-full blur-[100px] pointer-events-none" />

        <div className="relative">
          <p className="text-[#D4AF37] text-xs uppercase tracking-[4px] mb-6">
            {isEn ? "Page Not Found" : "Page introuvable"}
          </p>
          <h1 className="text-8xl md:text-9xl text-white font-bold mb-2 opacity-10" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            404
          </h1>
          <h2 className="text-2xl md:text-3xl text-white mb-4 -mt-12" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            {isEn ? "This page doesn't exist" : "Cette page n'existe pas"}
          </h2>
          <p className="text-slate-400 text-sm max-w-md mx-auto mb-10 leading-relaxed">
            {isEn
              ? "The page you are looking for may have been moved, removed, or never existed. Let us guide you back."
              : "La page que vous recherchez a peut-etre ete deplacee, supprimee ou n'a jamais existe."}
          </p>
          <div className="flex items-center justify-center gap-4">
            <Link
              to="/"
              data-testid="404-home-link"
              className="btn-gold bg-[#D4AF37] text-[#0B1221] px-6 py-3 text-xs font-bold uppercase tracking-wider hover:bg-[#F59E0B] inline-flex items-center gap-2"
            >
              <Home size={14} />
              {isEn ? "Back to Home" : "Retour a l'accueil"}
            </Link>
            <Link
              to="/blog"
              data-testid="404-blog-link"
              className="border border-[#D4AF37] text-[#D4AF37] px-6 py-3 text-xs font-bold uppercase tracking-wider hover:bg-[#D4AF37] hover:text-[#0B1221] transition-all duration-300 inline-flex items-center gap-2"
            >
              <ArrowLeft size={14} />
              {isEn ? "Read Our Blog" : "Lire le blog"}
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
